<div class="mx-auto">
    <jois-team-container class="d-block my-2 my-md-5"></jois-team-container>
</div>
